import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'
import router from '@/router'

const initForm = async () => {
  const formStore = useFormStore()
  const { fileNumber, requestNumber, withException, serviceTransactionId, administrativeRegionId } =
    router.currentRoute.value.query
  if (serviceTransactionId && administrativeRegionId) {
    formStore.draft = {
      ...formStore.draft,
      serviceTransactionId,
      administrativeRegionId,
      withException: withException === 'true'
    }
  }
  if (requestNumber) {
    let res = await apiHelperService.get(
      `/api/individual/preEntryExtend/draft/request/${requestNumber}`
    )
    if (res) {
      formStore.draft = {
        ...formStore.draft,
        ...res
      }
    }
  } else if (fileNumber) {
    const params = { fileNumber: fileNumber }
    let res = await apiHelperService.get(
      `/api/individual/preEntryExtend/checkValidateVisaOnArrival`,
      {
        params
      }
    )
    if (res) {
      const {
        englishName,
        arabicName,
        currentNationalityId,
        dateOfBirth,
        departmentCode,
        serviceYear,
        serviceCode,
        sequenceNumber,
        passportTypeId,
        passportNumber,
        sponsorTypeId,
        emailAddress
      } = response.request || {}
      formStore.draft = {
        ...formStore.draft,
        serviceTransactionId,
        request: {
          ...formStore.draft.request,
          serviceTransId: serviceTransactionId,
          englishName,
          arabicName,
          currentNationalityId,
          dateOfBirth,
          departmentCode,
          serviceYear,
          serviceCode,
          sequenceNumber,
          passportTypeId,
          passportNumber,
          sponsorTypeId,
          emailAddress
        }
      }
      formStore.form.setValues({
        englishName,
        arabicName,
        currentNationalityId,
        dateOfBirth,
        departmentCode,
        serviceYear,
        serviceCode,
        sequenceNumber,
        passportTypeId,
        passportNumber,
        sponsorTypeId,
        emailAddress
      })
    }
  }
}
const fetchInfo = async () => {
  const formStore = useFormStore()
  const res = await apiHelperService.get(`/api/individual/info`)
  formStore.form.setFieldValue('individualInfo', res)
}
const initInfo = async () => {
  const res = await fetchInfo()
}

export default async function () {
  try {
    await initForm()
    await initInfo()
  } catch (error) {
    console.error('use996Preload', error)
  }
}
